"use client";

interface VideoBackgroundProps {
  videoSrc: string;
  onVideoStarted?: () => void;
  className?: string;
}

export const VideoBackground = ({ videoSrc, onVideoStarted, className }: VideoBackgroundProps) => {
  return (
    <video
      muted
      playsInline
      autoPlay
      loop
      src={videoSrc}
      onPlay={onVideoStarted}
      className={`w-full h-full ${className ?? ''}`}
    />
  );
};
